export const GENERAL_ERROR_MESSAGE_HEADER = 'Unexpected Application Error!'
export const GENERAL_ERROR_MESSAGE__SUB_HEADER_1 = 'Apparently something went wrong on the server side.'
export const GENERAL_ERROR_MESSAGE__SUB_HEADER_2 = 'Please try to refresh the page.'
